import { ToastOptions } from "react-hot-toast";

export const COMPLETE_TOAST_CONFIG: ToastOptions = {
  position: "top-center",
  style: {
    background: "#F7F8F9",
    color: "#242628",
    borderRadius: "12px",
  },
};
